<script lang="ts">
	import { getGlobalSettings } from "../contexts/getGlobalSettings.js";

	const { COOKIES } = getGlobalSettings();

	/* eslint-disable svelte/no-at-html-tags */
</script>

{@html `<script type="text/javascript" charset="UTF-8" data-cookiescriptreport="report" src="//report.cookie-script.com/r/${COOKIES}.js"></script>`}
